import React from 'react'

// Types 
import { ValidatorProps } from '../types'

// Styles
import styles from '../styles/Validator.scss'

// Hooks 
import { useState, useEffect } from 'react'

const RequiredValidator: React.FC<ValidatorProps> = (props) => {

    const [error, setError] = useState(false)
    const [initial, setInitial] = useState(true)
    const { value, validate, children } = props

    useEffect(() => {
        if(initial) setInitial(false) 
        else handleValidation()
    }, [value])

    const handleValidation = () => {
        const error = !validate()
        setError(error)
    }

    if(initial || !error) return null

    return (
        <div className={props.className || styles.validationMessage}>
            {children}
        </div>
    )

}

export default RequiredValidator